import { useState, useEffect } from "react";

import { AgGridReact } from "ag-grid-react";
// import { getManufacturerByID } from "@/api/Manufacturers";
import { useSelector } from "react-redux";
// import { getVendorById } from "@/api/Vendor";
// import { getCategoryById } from "@/api/Category";

export default function AgTable({
  columns,
  perPage = 10,
  getTableRows,
  refresh,
  setRefresh,
  classN,
  setGridData,
  gridOptions,
  components,
  gridApi,
  setGridApi
}) {
  // const {data:user}=useSelector((state)=>state?.login)
  // const [tableRefreshCount, setTableRefreshCount] = useState(0);

  function onSortChanged() {
    // setTableRefreshCount((prev) => prev + 1);
  }

  const onGridReady = (params) => {
    setGridApi(params.api);
    // setGridData(params.api);
  };

  useEffect(() => {
    if (gridApi) {
      const dataSource = {
        getRows: async (params) => {
          gridApi?.showLoadingOverlay();
          const { rows, total, error } = await getTableRows(
            perPage,
            params.endRow - perPage
          );
          gridApi?.hideOverlay();
          gridApi.resetRowHeights();
          if (error) {
            params?.successCallback([], 0);
            // setRefresh(false);
          } else {
            params?.successCallback(rows, parseInt(total));
            // setRefresh(false);
          }
        },
      };
      gridApi?.setDatasource(dataSource);
    }
  }, [gridApi, refresh]);
  const handleCellValueChanged = async(event) => {
    console.log( event.data,"befor")
//     const cellData = event.data;
//     const column = event.colDef.field;
//     if (column === "manufacturer") {
//         try{
//         const {data} =await getManufacturerByID(user.token,cellData?.manufacturer)

//         const unitPrice = parseFloat(cellData.unit_price);
//         const discount = parseFloat(data.data.discount);
//         const markupValue = parseFloat(data.data.markupvalue);
//         const calculatedOurCost = unitPrice - (unitPrice * discount) / 100;
//         const calculatedCustomerPrice = calculatedOurCost * markupValue;
//         cellData.cost =calculatedOurCost
//         cellData.customer_price =calculatedCustomerPrice
//         cellData.manufacture_name=data.data.manufacture_name
//         gridApi.applyTransaction({
//           update: [{ data: { ...cellData, cost: calculatedOurCost, customer_price: calculatedCustomerPrice } }],
//         });
//       gridApi.refreshCells({ rowNodes: [event.node], force: true });

//         }catch(error){
//            console.log(error?.message)
//         }
//     }
//     if (column === "vendor_id") {
//       const { oldValue, newValue, colDef, data, rowIndex } = event;
//       try {
//         const { data } = await getVendorById(user.token,newValue);
//       cellData.vendor_name= data.data.Vendor.vendor_name,
//       gridApi.refreshCells({ rowNodes: [event.node], force: true });
//       } catch (error) {
//         console.error(error?.message);
//       }
   
    
//   }
//   if (column === "category") {
//     const { oldValue, newValue, colDef, data, rowIndex } = event;
//     try {
//       const { data } = await getCategoryById(user.token,newValue);
//     cellData.category_name= data.data.category_name
//     gridApi.refreshCells({ rowNodes: [event.node], force: true });
//     } catch (error) {
//       console.error(error?.message);
//     }
 
  
// }
  };
  
  return (
    <div aria-live="polite" aria-busy={false} className="ag-theme-material">
      <AgGridReact
      ref={gridApi}
        columnDefs={columns}
        pagination={true}
        className={classN ? `tableIndex` : ""}
        rowModelType="infinite"
        paginationPageSize={perPage}
        cacheBlockSize={perPage}
        onGridReady={onGridReady}
        onSortChanged={onSortChanged}
        onCellValueChanged={handleCellValueChanged}
        domLayout="autoHeight"
        onColumnResized={() => gridApi?.resetRowHeights()}
        defaultColDef={{
          resizable: true,
          flex: 1,
          autoHeaderHeight: true,
        }}
        overlayNoRowsTemplate={`<dotlottie-player src="https://lottie.host/8d707969-8fe6-43a6-ad1e-234e6eccfd1c/ui7oGj8149.json" background="transparent" speed="1" style="width:200px; height:200px" direction="1" playMode="normal" loop autoplay></dotlottie-player>`}
        components={components}
        gridOptions={gridOptions}
          editType="fullRow"
          
            // enableCellTextSelection={true}
      />
    </div>
  );
}
